import React, { Component } from "react"
import { Grid, Row, Col, Image } from "react-bootstrap"
import { Link } from "react-router-dom"
import Lazyload from "react-lazyload-fadein"

import Sidebar from "../components/Sidebar.js"
import { Seo } from "../components/Seo.js"
import { cdnUrl } from "../config.prod"
import { getStories } from "../helpers/api.js"

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      stories: null
    }
  }

  componentDidMount() {
    getStories("featured")
      .then(({ items }) => {
        this.setState({
          stories: items
            .sort(({ storiesOrder: a = 0 }, { storiesOrder: b = 0 }) => b - a)
            .splice(0, 3)
            .map(({ PK, cover }) => ({
              alias: PK,
              cover: cover.includes("d1gi8uwv7isx4g.cloudfront.net") ? cover.replace("thumbs", "medium") : cover.substring(0, 5) === "https" ? cover : `${cdnUrl}/medium/${cover}.jpg`
            }))
        })
      })
  }

  render() {
    return(
      <div className = { "home-stories" }>
        <Seo title="Home"></Seo>
        <Grid fluid>
          <Row>
            <Col md = { 1 }>
              <Sidebar />
            </Col>
            <Col md = { 11 }>
              <Row className = { "story-grid center-vertically-md" }>
                {
                  this.state.stories &&
                  this.state.stories.map(({ alias, cover }) => (
                    <Col md = { 4 } key={ alias } >
                      <div className = { "img-wrapper" }>
                        <Link to={`/stories/${alias}`}>
                          <Lazyload height = { 300 }>
                            {
                              onLoad => (
                                <Image
                                  className = { "menu-thumb" }
                                  src = { cover }
                                  onLoad = { onLoad }
                                />
                              )
                            }
                          </Lazyload>
                        </Link>
                      </div>
                    </Col>
                  ))
                }
              </Row>
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default Home



// WEBPACK FOOTER //
// ./src/containers/Home.js